/**
 * 聊天记录本地存储管理工具
 * 解决平台存储量限制问题和分页问题
 */

class ChatStorageManager {
  constructor() {
    // 属性已在声明时初始化
  }

  /**
   * 生成存储key
   * @param {string} currentUserId - 当前用户ID
   * @param {string} friendUserId - 好友用户ID
   * @returns {string} 存储key
   */
  generateStorageKey(currentUserId: number, friendUserId: number): string {
    // 确保key的一致性，无论谁是currentUserId
    const ids = [currentUserId, friendUserId].sort()
    return `chat_${ids[0]}_${ids[1]}`
  }
  // 设置聊天记录列表
  setList(currentUserId: number, friendUserId: number, messages: any[]) {
    const storageKey = this.generateStorageKey(currentUserId, friendUserId)
    return localStorage.setItem(storageKey, JSON.stringify(messages))
  }

  getList(currentUserId: number, friendUserId: number) {
    const storageKey = this.generateStorageKey(currentUserId, friendUserId)
    const list = localStorage.getItem(storageKey)
    if (list) {
      return JSON.parse(list)
    } else {
      return []
    }
  }
}

// 导出单例实例
export default new ChatStorageManager()
